<template>
  <div
    class="tracking-wider py-8 px-4 border-b border-black last:border-0"
  >
    <h1
      class="text-2xl select-none cursor-pointer"
      :class="{ 'activetitle': artist == content.title}"
      @click="$emit('openArtist', { name: content.title, index: index })"
    >
      {{ content.title }}
    </h1>
    <div class="pt-4 text-base" v-if="artist == content.title">
      <div class="space-y-4 mb-4" v-html="content.text"></div>
      <div class="space-y-4 text-sm px-8" v-html="content.bio"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: Number,
    content: Object,
    artist: String,
  },
  data() {
    return {
      active: false,
    };
  },
};
</script>
